exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-valid .empty, .not-valid .error {\n  border: 1px solid red;\n}\n", ""]);

// exports
